import { enumToOptions } from '@libs/types/src/common/enum/util';

export enum PersonInformationProviderEnum {
    PERSON = "person",
    FAMILY = "family",
    INSTITUTION = "institution",
    OTHER = "other",
}

export const personInformationProviderEnumOptions = enumToOptions(PersonInformationProviderEnum, 'person.enum.informationProvider.');
